import { render, staticRenderFns } from "./UserOverview.vue?vue&type=template&id=2baaab64&"
import script from "./UserOverview.vue?vue&type=script&lang=ts&"
export * from "./UserOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserOverview.vue"
export default component.exports